import React from "react";
import Image from "next/image";

import { useAuth } from "../auth/auth";
import logo from "/public/assets/images/logo.svg";
import logoLight from "/public/assets/images/logo-white.svg";

export default function Logo({ light, onClick }) {
  const { userSignOut } = useAuth();
  return (
    <Image
      className=" cursor-pointer"
      src={light ? logoLight : logo}
      alt="channel"
      layout="responsive"
      onClick={onClick ? onClick : userSignOut}
      priority
    />
  );
}
